<button *ngIf="['xs', 'sm'].includes(layout.width$ | async)" (click)="closeSelf()" type="button" class="mobile-close">
    <i class="icon-close"></i>
</button>

<ng-template cdkPortalOutlet></ng-template>